(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-house-collection]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const cards = Array.from(root.querySelectorAll('[data-house-card]'));
      root.querySelectorAll('[data-house-filter]').forEach(button => button.addEventListener('click', () => {
        const tone = button.dataset.houseFilter;
        root.querySelector('.oh-collection-grid')?.classList.toggle('ow-filtered', tone !== 'all');
        root.querySelectorAll('[data-house-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let visible = 0;
        cards.forEach(card => { card.hidden = tone !== 'all' && card.dataset.tone !== tone; if (!card.hidden) visible++; });
        const count = root.querySelector('[data-house-count]');
        if (count) count.textContent = count.dataset.countTemplate.replace('__COUNT__', String(visible));
      }));
    });
    scope.querySelectorAll('[data-house-product]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const data = JSON.parse(root.querySelector('[data-house-variants]').textContent);
      const format = new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency || 'USD'});
      const update = (id, writeUrl) => {
        const variant = data.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        const title = variant.option1 || variant.title;
        const size = /15\s*m/i.test(title) ? '15' : /50\s*m/i.test(title) ? '50' : '2';
        const photo = root.querySelector('.oh-product-image');
        const sample = root.querySelector('[data-sample-photo]');
        const bottle = root.querySelector('[data-bottle-photo]');
        if (sample) sample.hidden = size !== '2';
        if (bottle) bottle.hidden = size === '2';
        if (size !== '2' && photo) {
          photo.removeAttribute('srcset');
          photo.src = data.images[size];
          photo.alt = data.labels.caption.replace('__SIZE__', size);
        }
        root.querySelector('[data-photo-caption]').textContent = size === '2' ? data.labels.sampleCaption : data.labels.caption.replace('__SIZE__', size);
        root.querySelector('[data-variant-price]').textContent = format.format(variant.price / 100);
        root.querySelector('[data-selected-format]').textContent = variant.option1 || variant.title;
        root.querySelector('.oh-purchase input[name="id"]').value = variant.id;
        const available = variant.available && !data.comingSoon;
        const buy = root.querySelector('.oh-purchase button');
        buy.hidden = !available; buy.disabled = !available;
        root.querySelector('.oh-notify-button').hidden = available;
        root.querySelector('.oh-notify-note').hidden = available;
        root.querySelector('[data-availability]').textContent = data.comingSoon ? data.labels.soon : variant.available ? data.labels.available : data.labels.soldOut;
        if (writeUrl) { const url = new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url); }
      };
      const inputs = Array.from(root.querySelectorAll('.oh-variants input'));
      const id = new URL(window.location.href).searchParams.get('variant');
      const initial = inputs.find(input => input.value === id) || inputs.find(input => input.checked);
      if (initial) { initial.checked = true;update(initial.value,false); }
      inputs.forEach(input => input.addEventListener('change',()=>update(input.value,true)));
      window.addEventListener('popstate',()=>{const current=new URL(window.location.href).searchParams.get('variant');const input=inputs.find(item=>item.value===current);if(input){input.checked=true;update(current,false);}});
    });
  };
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('click',event=>{const link=event.target.closest('.oh-menu a');if(link)link.closest('details').open=false;});
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const menu=document.querySelector('.oh-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}});
})();
